<script setup lang="ts">
const props = defineProps<{ data: HeroProps; template?: 'page' | 'overlay' }>()

const insertAt = (str: string, sub: string, pos: number) =>
  `${str.slice(0, pos)}${sub}${str.slice(pos)}`

const titleWithLineBreaks = computed(() => {
  if (!props.data.title) return

  const lineBreak = '&shy;'
  
  const words = props.data.title.split(' ')
  const brokenWords = words.map(word => word.length > 8 ? insertAt(word, lineBreak, 8) : word)


  return brokenWords.join(' ')
})
</script>

<template>
  <section
    class="px-bleed h-fit w-full overflow-clip pb-10"
    :class="{
      'bg-white': template !== 'page' && template !== 'overlay' && data.theme !== 'light-grey',
      'bg-light-grey':
        template === 'page' || (template !== 'overlay' && data.theme === 'light-grey'),
    }"
  >
    <!-- max-width is accounting for the close-button -->
    <h1
      class="font-display pt-11 text-3xl uppercase font-stretch-expanded lg:pt-16 lg:text-6xl"
      :class="{
        'max-w-[calc(100%-var(--grid-bleed)*2-3.5rem)]': template === 'overlay',
        'max-w-[12.5em]': template === 'page',
      }"
      v-html="titleWithLineBreaks"
    ></h1>

    <ElementsPortableTextWrapper v-if="data.text" class="pt-8 text-lg" :content="data.text" />

    <CommonMedia
      :sizes="['80vw', '66vw']"
      class="mt-10 h-auto w-full"
      :media="data.media"
      :aspect="[4 / 5, 16 / 9]"
      :fill="'both'"
      :loading="'eager'"
    />
  </section>
</template>
